import { ProductAbbreviations } from '@/creditflowresearch/domain/Product';
import { IconComponentType } from '@creditflowresearch/uilib/Icon';

export const BADGE_TYPES = {
  BETA: 'Beta',
  NEW: 'New',
  PRO: 'Pro',
} as const;

export type BadgeType = typeof BADGE_TYPES[keyof typeof BADGE_TYPES];

export const TOOL_CATEGORIES = {
  MARKET_OVERVIEW: 'market-overview',
  REGULAR: 'regular',
} as const;

export type ToolCategory = typeof TOOL_CATEGORIES[keyof typeof TOOL_CATEGORIES];

export default interface ITools {
  additionalName: string,
  applicationName: string,
  beta: boolean,
  external: boolean,
  id: string,
  name: string,
  new: boolean,
  path: string,
}

export interface ITool {
  id: string,
  name: string,
  additionalName?: string | null,
  applicationName?: string,
  beta?: boolean,
  new?: boolean,
  external?: boolean,
  route?: string,
  skipProductRegionAppend?: boolean | string,
  pro?: boolean,
  outOfDomain?: boolean,
  path?: string,
}

export interface IToolLinkOption {
  link: string,
  text: React.ReactNode,
  onClick?: () => void,
  isActive?: boolean,
  IconComponent?: IconComponentType,
  badges?: string[],
}

export interface IPanelTools {
  title?: React.ReactNode,
  topOptions?: IToolLinkOption[],
  toolsOptions?: IToolLinkOption[],
}

export interface IToolTransformContext {
  activeProductAbbreviation: string,
  activeRegionAbbreviation: string,
  productAbbreviation: ProductAbbreviations,
  productId: string,
}

export interface IToolCategory {
  marketOverviewTools: ITool[],
  regularTools: ITool[],
}

export interface IProcessToolsOptions {
  tools: ITool[],
  activeProductAbbreviation: string,
  activeRegionAbbreviation: string,
  productAbbreviation: ProductAbbreviations,
  productId: string,
}

export interface IProcessedTools {
  topOptions: IToolLinkOption[],
  toolsOptions: IToolLinkOption[],
}

export interface ILinkBuilder {
  canBuild(tool: ITool, context?: ILinkContext): boolean,
  build(tool: ITool, context: ILinkContext): string,
}

export interface ILinkContext {
  activeProductAbbreviation: string,
  activeRegionAbbreviation: string,
}

export interface IUsePanelToolsOptions {
  panelId: string,
  regionId?: string,
}
